// The SETTINGS config for a UserUnitPriceAttribute MACHINE type, seeded on window by frank/edit.html.erb (which
// rendered it from QUOTE_BUILDER_CONFIG_SETTINGS, because the /mcc page itself is handed the SECTIONS config), and
// the UserUnitPriceAttribute tab within it -- the machine-manager list (SettingsUserUnitPriceAttributeList) is
// driven by that tab. Shared by the filter-island add/manage button and the empty-state adder, and keyed by the
// attribute key so ONE implementation serves 'printing_machine' AND 'die_cutting_machine'.
export const machineSettingsConfig = (key) => window[`frank_${key}_settings_config`] || {};

export const machineTabConfig = (key) => (
  (machineSettingsConfig(key).tabs || []).find((tab) => tab.form_type === 'UserUnitPriceAttribute')
);

// The owner's own count of this machine type, seeded by the page (so a button label is right on first paint) and
// kept fresh on window as machines are added, so a later read -- or a remount -- sees the honest number.
export const machineCount = (key) => Number(window[`frank_${key}_count`]) || 0;

export const setMachineCount = (key, value) => { window[`frank_${key}_count`] = value || 0; };
